import config from "config";
import React from "react";
import { Select, Avatar, Space } from "antd";
import { useTranslation } from "react-i18next";
import cls from "./LanguageSelect.module.scss";

const flagMap = {
  uz: "https://flagcdn.com/16x12/uz.png",
  oz: "https://flagcdn.com/16x12/uz.png",
  ru: "https://flagcdn.com/16x12/ru.png",
  en: "https://flagcdn.com/16x12/gb.png",
};

const LanguageSelect = () => {
  const { i18n } = useTranslation();

  const handleChange = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className={cls.wrapper}>
      <Select
        value={i18n.language}
        onChange={handleChange}
        className={cls.select}
        // optionLabelProp="label"
      >
        {config.language.list.map((lng) => (
          <Select.Option
            key={lng}
            value={lng}
            label={
              <Space>
                <Avatar src={flagMap[lng]} size={16} />
                {lng.toUpperCase()}
              </Space>
            }>
            <Space>
              <Avatar src={flagMap[lng]} size={16} />
              {lng.toUpperCase()}
            </Space>
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default LanguageSelect;
